export default "__VITE_ASSET__CcRI1f8e__"